import { getSocialProofTemplate, getVueSocialProofTemplate } from "../../shortcodes/templates";

let socialProof = null;

const visualizeSocialProof = content => {
  socialProof = content.querySelectorAll('[data-wrapper-id="social-proof"]');
  if (socialProof.length > 0) {
    socialProof.forEach(item => {
      item.innerHTML = getSocialProofTemplate();
    });
  }
};

const serializeSocialProof = content => {
  socialProof = content.querySelectorAll('[data-wrapper-id="social-proof"]');
  if (socialProof.length > 0) {
    socialProof.forEach(item => {
      const proofData = item.getAttribute("data-social-proof-data");
      item.innerHTML = getVueSocialProofTemplate(proofData);
    });
  }
};

export { visualizeSocialProof, serializeSocialProof };
